import React, { useState, useEffect } from "react";
import {
  Card,
  Table,
  DatePicker,
  Row,
  Col,
  Typography,
  Space,
  Tag,
} from "antd";
import useRequest from "../../hooks/useRequest";
import apiPath from "../../constants/apiPath";
import moment from "moment";

const { Title } = Typography;

const DailyTripReports = () => {
  const { request } = useRequest();
  const [reports, setReports] = useState([]);
  const [loading, setLoading] = useState(false);
  const [filterDate, setFilterDate] = useState(null);

  const fetchReports = () => {
    setLoading(true);
    const params = {};
    if (filterDate) params.date = filterDate.format("YYYY-MM-DD");

    request({
      url: apiPath.busDailyReport,
      method: "GET",
      params,
      onSuccess: (data) => {
        setReports(data.reports);
        setLoading(false);
      },
      onError: () => setLoading(false),
    });
  };

  useEffect(() => {
    fetchReports();
  }, [filterDate]);

  const columns = [
    {
      title: "Date",
      dataIndex: "date",
      key: "date",
      render: (date) => moment(date).format("DD-MM-YYYY"),
    },
    {
      title: "Airport → Hotel (One-way)",
      dataIndex: "oneWay",
      key: "oneWay",
      render: (val) => <Tag color="blue">{val}</Tag>,
    },
    {
      title: "Hotel → Airport (Return)",
      dataIndex: "roundTripReturn",
      key: "roundTripReturn",
      render: (val) => <Tag color="green">{val}</Tag>,
    },
    {
      title: "Airline-wise Breakdown",
      dataIndex: "airlines",
      key: "airlines",
      render: (airlines) => (
        <Space direction="vertical" style={{ width: "100%" }}>
          {Object.entries(airlines).map(([name, count]) => (
            <div key={name} style={{ display: "flex", justifyContent: "space-between" }}>
              <span>{name}:</span>
              <strong>{count}</strong>
            </div>
          ))}
        </Space>
      ),
    },
  ];

  return (
    // <Main>
    <div className="layout-content">
      <Card
        bordered={false}
        className="criclebox h-full"
        title={
          <Title level={4} style={{ margin: 0 }}>
            Daily Trip Reports
          </Title>
        }
        extra={<DatePicker
          placeholder="Filter by Date"
          onChange={(val) => setFilterDate(val)}
        />}
      >
        <Table
          columns={columns}
          dataSource={reports}
          loading={loading}
          rowKey="date"
          scroll={{ x: "max-content" }}
          pagination={{ pageSize: 15 }}
        />
      </Card>
    </div>
    // </Main>
  );
};

export default DailyTripReports;
